import { render, staticRenderFns } from "./newShop.vue?vue&type=template&id=59001d08&scoped=true"
import script from "./newShop.vue?vue&type=script&lang=js"
export * from "./newShop.vue?vue&type=script&lang=js"
import style0 from "./newShop.vue?vue&type=style&index=0&id=59001d08&prod&scoped=true&lang=scss&ref=stylesheet%2Fscss"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59001d08",
  null
  
)

export default component.exports